import { render, staticRenderFns } from "./ActivityWindowView.vue?vue&type=template&id=7684a003&scoped=true&"
import script from "./ActivityWindowView.vue?vue&type=script&lang=js&"
export * from "./ActivityWindowView.vue?vue&type=script&lang=js&"
import style0 from "./ActivityWindowView.vue?vue&type=style&index=0&id=7684a003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7684a003",
  null
  
)

export default component.exports